export const HOME = '/';

// Bot Builder
export const CHATBOT_EDITOR = '/chatbot-editor';
export const CHATBOT_EDITOR_TRIGGER = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/trigger`;
export const CHATBOT_HOME = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/home`;
export const CHATBOT_EDITOR_ZAPIER_ANY_BOT = `${CHATBOT_EDITOR}/zapier`;

export const CHATBOT_EDITOR_CAMPAIGN_REPORT = (
  botId: number,
  campaignId: number,
) => `${CHATBOT_EDITOR}/${botId}/campaign-report/${campaignId}`;
export const CHATBOT_EDITOR_DRIP_CAMPAIGN_DETAILS = (
  botId: number,
  campaignId?: number,
) =>
  `${CHATBOT_EDITOR}/${botId}/drip-campaign-detail${
    campaignId ? `/${campaignId}` : ''
  }`;
export const CHATBOT_EDITOR_RSS_FEEDS = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/rss-feeds`;

// MISC
export const REFRESH = '/refresh';
export const LOGIN = '/login';
export const SIGNUP = '/signup';
export const USERS = '/users';
export const SIGNOUT = '/signout';
export const CONNECT_PAGE = '/connect-page';
export const SUBSCRIBE = '/subscribe';

// DASHBOARD
export const COMPANY = '/company';

// ONBOARDING
export const TEMPLATES = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/templates`;

// SETTINGS
export const SETTINGS = '/settings';
export const SETTINGS_MY_ACCOUNT = `${SETTINGS}/my-account`;

export const CHATBOT_EDITOR_SETTINGS = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings`;

export const SETTINGS_CHATBOT = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/chatbot`;

export const SETTINGS_INBOX = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/inbox`;

export const SETTINGS_CUSTOMER_CHAT_WIDGET = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/customer-chat-widget`;

export const SETTINGS_SYSTEM_MESSAGES = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/system-messages`;

export const SETTINGS_ADVERTISING = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/advertising`;

export const SETTINGS_USERS = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/users`;

export const SETTINGS_MAINTENANCE = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/maintenance`;

export const SETTINGS_SMS = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/sms`;

export const SETTINGS_MM_API = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/public-api`;

export const SETTINGS_SMS_ACTIVATE_PATH = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/sms/activate`;

export const SETTINGS_SMS_VIEW_NUMBER_PATH = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/sms/number`;

export const SETTINGS_SMS_AREA_CODE_SEARCH_PATH = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/sms/area-code-search`;

export const SETTINGS_TEMPLATES = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/templates`;

export const TEMPLATES_LIBRARY = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/templates/library`;

export const TEMPLATES_FIND = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/templates/find-by-code`;

export const MY_TEMPLATES = (botId: number) =>
  `${CHATBOT_EDITOR}/${botId}/settings/templates/my-templates`;

export const BUILD_DIALOGUE = (botId: number, dialogueId: number) =>
  `${CHATBOT_EDITOR}/${botId}/build/${dialogueId}`;
